import { sendPost } from '../http.js'
const api = {
	'getExplainCardListAPI': { // 获取讲解卡列表
        url: '/author/course/live_anchor'
    },
    'addEditDelExplainCardAPI': { // 添加/编辑/删除讲解卡
        url: '/author/course/live_anchor/update'
    },
    'getForCardClassListAPI': { // 获取设置讲解卡专用的课程列表
        url: '/author/course/product_anchor/list'
    },
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        ...api[key],
        requestFun:(params, method='post', headers) => {
            return sendPost(api[key].url, params, method, headers)
        }
    } 
}
export default requestFunObj
